import React from "react";
import CustomDrawer from "./CustomDrawer";
import PageContent from "./PageContent";

export function Layout(props) {
  return (
    <CustomDrawer>
      <PageContent>{props.children}</PageContent>
    </CustomDrawer>
  );
}
